import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { UserAuthService } from 'app/services/api-service/user-auth-service/user-auth-service';

@Injectable({
  providedIn: 'root',
})
export class NonUserAuthGuard implements CanActivate {
  constructor(
    private userAuthService: UserAuthService,
    private router: Router,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean | UrlTree> {
    return new Promise((resolve, reject) => {
      this.userAuthService.getSession().then((res) => {
        if (res.tokens) {
          resolve(this.router.parseUrl('/cookbook'));
        } else {
          resolve(true);
        }
      });
    });
  }
}
